module.exports = __webpack_public_path__ + "static/media/Stellar Max King Headboard - 180 cm_Charcoal.2859dbd0.png";